import React from 'react'
import { Link } from 'react-router-dom'

const Index = () => {

    const refreshRegister = () => {
        window.location.reload()
    }

    return(
        <div className="failed-container">
            <h1 className="failed-icon"><i class="fad fa-times"></i></h1>
            <h3 className="failed-title">Kunne ikke opprette bruker</h3>
            <p className="failed-description">Det skjedde en feil i prosessen, og konto ble dessverre ikke opprettet.</p>
            <Link onClick={() => refreshRegister()} to="#"><button className="go-back-button">Prøv på nytt</button></Link>
        </div>
    )
}

export default Index